/**
 * 案件番号の表示形式。
 *
 * 現状 SpiffArena には業務採番の仕組みがなく、一次識別子は
 * process_instance.id（非負の連番）だけ。UI ではこれを `#1234` として見せる。
 * 将来 metadata_extraction_paths による業務採番に差し替える場合も、
 * 呼び出し側は caseNumber 文字列を扱うだけで済むようここに閉じ込める。
 */

const CASE_NUMBER_PREFIX = "#";

/** process instance id を表示用の案件番号にする。桁区切りは入れない（ID であって数量ではない）。 */
export function formatCaseNumber(processInstanceId: number): string {
  return `${CASE_NUMBER_PREFIX}${processInstanceId}`;
}

/**
 * 表示用の案件番号を process instance id に戻す。
 * `#` は省略可（URL パラメータ由来の値をそのまま渡せる）。
 * 非負整数として解釈できなければ null。
 */
export function parseCaseNumber(caseNumber: string): number | null {
  const body = caseNumber.trim().replace(/^#/, "");
  // parseInt の部分一致（"12abc" → 12）を避けるため厳密に検査する
  if (!/^\d+$/.test(body)) return null;

  const parsed = Number(body);
  return Number.isSafeInteger(parsed) ? parsed : null;
}
